import React from "react";
import IncomeDetails from "../../components/common/create-profile/income/index";
import CreateProfileLayout from "../layout";
const Income = () => {
  return (
    <CreateProfileLayout>
      <IncomeDetails />
    </CreateProfileLayout>
  );
};

export default Income;
